import { ScrollBar } from "./ScrollBar";
export class VScrollBar extends ScrollBar {
}
